var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullbody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 6,
    r: 3.25,
    stroke: "black",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2402 10.75H5.75977C5.2021 10.75 4.75003 11.2021 4.75 11.7598C4.75 12.1865 5.01813 12.5673 5.41992 12.7109L10.4326 14.501C11.2546 14.7945 11.7354 15.6492 11.5586 16.5039L9.23242 27.7471C9.0721 28.5227 9.664 29.2499 10.4561 29.25H10.7637C11.2371 29.25 11.6701 28.9821 11.8818 28.5586L14.4346 23.4531C15.0795 22.1635 16.9205 22.1635 17.5654 23.4531L20.1182 28.5586C20.3299 28.9821 20.7629 29.25 21.2363 29.25H21.5439C22.336 29.2499 22.9279 28.5227 22.7676 27.7471L20.4414 16.5039C20.2646 15.6492 20.7454 14.7945 21.5674 14.501L26.5801 12.7109C26.9819 12.5673 27.25 12.1865 27.25 11.7598C27.25 11.237 26.8528 10.8067 26.3438 10.7549L26.2402 10.75Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullbody);
export default __webpack_public_path__ + "static/media/Fullbody.e6b228d18be2dacfac3c3c5944f8bb9f.svg";
export { ForwardRef as ReactComponent };